import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
// import AdminWrapper from './Admin/adminWrapperContainer';
// import LoginPage from './Auth/loginContainer';
import NotFound from './Global/notFoundContainer';
// import MapPage from './Map/mapPageContainer';
import configureStore from './store/configureStore';

const MapPage = React.lazy(() => import('./Map/mapPageContainer'));
const LoginPage = React.lazy(() => import('./Auth/loginContainer'));
const AdminWrapper = React.lazy(() => import('./Admin/adminWrapperContainer'));

const store = configureStore();

export class RouterApp extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Provider store={store}>
                <React.Suspense fallback={<div />}>
                <HashRouter>
                    <Switch>
                        <Redirect
                            exact
                            path="/"
                            to="/ru/map"
                        />
                         <Redirect
                            exact
                            path="/ru"
                            to="/ru/map"
                        />
                        <Redirect
                            exact
                            path="/en"
                            to="/en/map"
                        />
                        <Redirect
                            exact
                            path="/map"
                            to="/ru/map"
                        />
                        <Route
                            path="/login"
                            component={LoginPage}
                        />
                        <Route
                            path="/:lang/map/:saveId?"
                            component={MapPage}
                        />
                        <Route
                            path="/admin"
                            component={AdminWrapper}
                        />
                        <Route component={NotFound}/>
                    </Switch>
                </HashRouter>
                </React.Suspense>
            </Provider>
        );
    }
}
